import { RequirePayoutsAccountingSettingsUser } from '@/components/auth/RequirePayoutsAccountingSettingsUser';
import { OrganizationNode } from '@/types/Organizations';
import { Box, Button } from '@palmetto/palmetto-components';

interface InvoiceSettingsCardHeaderProps {
  organization?: OrganizationNode | undefined;
  onClick?: () => void;
  cardTitle: string;
}

export const InvoiceSettingsCardHeader = ({ organization, cardTitle, onClick }: InvoiceSettingsCardHeaderProps) => {
  return (
    <Box childGap="lg" padding="lg" alignItems="center" direction="row" justifyContent="space-between">
      <Box as="h3" fontWeight="medium" fontSize="md">
        {cardTitle}
      </Box>
      <RequirePayoutsAccountingSettingsUser>
        {organization && (
          <Button
            variant="secondary"
            tone="neutral"
            size="sm"
            aria-label="Edit Invoice Schedule"
            iconPrefix="pencil"
            onClick={onClick}
          >
            Edit
          </Button>
        )}
      </RequirePayoutsAccountingSettingsUser>
    </Box>
  );
};
